import { Popover } from "frontend/src/components/Overlay/Overlay";
import React, { useState } from "react";

import i18n from "i18next";
import config from "../config/config";
import { Link, useParams } from "react-router-dom";

const CreationMenu = () => {
  const [visible, setVisible] = useState(false);
  const { investmentId, companyId, firmId, dealId } = useParams();

  const hide = () => {
    setVisible(false);
  };

  const renderContent = () => {
    return (
      <div onClick={hide} className="add-popup-dropdown">
        <p className="add-popup-dropdown__title">
          {i18n.t("creation_menu.title")}
        </p>

        <a
          href={`${config.RCG_DATA_COLLECTION_URI()}/firm/create`}
          target="_blank"
          rel="noopener noreferrer"
          className="add-popup-dropdown__item"
        >
          <span className="add-popup-dropdown__item-icon icon icon-fund" />
          <span className="add-popup-dropdown__item-text">
            {i18n.t("creation_menu.firm")}
          </span>
        </a>

        <a
          href={`${config.RCG_DATA_COLLECTION_URI()}/investment/create`}
          target="_blank"
          rel="noopener noreferrer"
          className="add-popup-dropdown__item"
        >
          <span className="add-popup-dropdown__item-icon icon icon-columns" />
          <span className="add-popup-dropdown__item-text">
            {i18n.t("creation_menu.investment")}
          </span>
        </a>

        <a
          href={`${config.RCG_DATA_COLLECTION_URI()}/company/create`}
          target="_blank"
          rel="noopener noreferrer"
          className="add-popup-dropdown__item"
        >
          <span className="add-popup-dropdown__item-icon icon icon-fund" />
          <span className="add-popup-dropdown__item-text">
            {i18n.t("creation_menu.company")}
          </span>
        </a>

        <Link
          to={{
            pathname: "/multiDocumentUpload",
            search: (() => {
              if (investmentId) return `?investmentId=${investmentId}`;
              if (companyId) return `?companyId=${companyId}`;
              if (firmId) return `?firmId=${firmId}`;
              if (dealId) return `?dealId=${dealId}`;
              return "";
            })(),
          }}
          className="add-popup-dropdown__item"
        >
          <span className="add-popup-dropdown__item-icon icon icon-docs" />
          <span className="add-popup-dropdown__item-text">
            {i18n.t("creation_menu.document")}
          </span>
        </Link>

        <p className="add-popup-dropdown__item cursor-not-allowed">
          <span className="add-popup-dropdown__item-icon icon icon-team" />
          <span className="add-popup-dropdown__item-text">
            {i18n.t("creation_menu.person")}
          </span>
        </p>
      </div>
    );
  };

  return (
    <Popover
      placement="bottomRight"
      trigger="click"
      overlayClassName="nav-list"
      open={visible}
      onOpenChange={setVisible}
      getPopupContainer={triggerNode => triggerNode}
      content={renderContent()}
    >
      <div
        className="main-navbar__btn main-popup-dropdown"
        data-cy="creation-menu"
      >
        <span className="main-navbar__btn--add-icon icon icon-plus icon--28" />
      </div>
    </Popover>
  );
};

export default CreationMenu;
